export default {"src":"/_next/static/media/plus.f16a370a.svg","height":30,"width":30};